import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const AppsAccountsApiDataTable = lazy(() =>
  import("@components/AppsAccountsApiDataTable").then((module) => ({
    default: module.AppsAccountsApiDataTable,
  }))
);

export const AccountsNRO: NavigationRoutingObject = {
  Component: AppsAccountsApiDataTable,
  componentFeatureFlippers: ["accounts_nro_component"],
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("accounts-nro-heading", "Accounts"),
  pageNameForTracking: () => "Accounts",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("accounts-nro-description", "Manage account data, such as prospects and customers"),
  icon: "nav-system-accounts",
  tag: "beta",
  getDeveloperNavigationAllowed: ({ featureOn }) => featureOn("accounts_nro_component"),
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
};
